export class CategoryCreationDto {
  constructor(
    public id: number,
    public name: string,
    public parentId: number,
    public vocabCategoryIds: number[],
    public vocabEntryIds: number[],
    public functionalGrammarCategoryIds: number[],
    public functionalGrammarEntryIds: number[],
    public systemicGrammarCategoryIds: number[],
    public systemicGrammarEntryIds: number[],
    public textPatternIds: number[],
    public textTypeIds: number[],
    public detailedCanDoStatementCategoryIds: number[],
    public detailedCanDoStatementEntryIds: number[],
    public globalCanDoStatementCategoryIds: number[],
    public globalCanDoStatementEntryIds: number[],
    public verbalActionCategoryIds: number[],
    public verbalActionEntryIds: number[]
  ) {
  }
}
